import {
  GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS,
  GETVOUCHERTRANSACTIONDETAILSLIST_FAILED,
  RESET_GETVOUCHERTRANSACTIONDETAILSLIST,
  LOADING_GETVOUCHERTRANSACTIONDETAILSLIST,
  NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherTransactionDetails = () => {
  return { type: RESET_GETVOUCHERTRANSACTIONDETAILSLIST };
};

const getVoucherTransactionDetailsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVOUCHERTRANSACTIONDETAILSLIST });
    await partnerServices
      .post("getVoucherTransactionDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getVoucherTransactionDetailsListsuccess(res.data));
            break;
          default:
            dispatch(getVoucherTransactionDetailsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVOUCHERTRANSACTIONDETAILSLIST,
          payload: err,
        });
      });
  };
function getVoucherTransactionDetailsListsuccess(data) {
  return {
    type: GETVOUCHERTRANSACTIONDETAILSLIST_SUCCESS,
    payload: data,
  };
}
function getVoucherTransactionDetailsListFailed(data) {
  return {
    type: GETVOUCHERTRANSACTIONDETAILSLIST_FAILED,
    payload: data,
  };
}

export { resetGetVoucherTransactionDetails, getVoucherTransactionDetailsList };
